import { DocumentNode } from 'graphql';
import { print } from 'graphql/language/printer';

export function prepareQuery(query: DocumentNode, variables?: any) {
    return {
        query: print(query),
        variables
    }
}
